const getLinkedAccountsMenuMobileHeight = (height: number): number | string => {
  return 100 + (height * 78);
};

export default getLinkedAccountsMenuMobileHeight;